/**
 * State
 */
const state = {
    orderAvailability: {},
    loaded: false,
    order: {
        devices: {},
        trackingVan: null
    },
};

/**
 * Getters
 */
const getters = {
    /** Has an order been loaded? **/
    orderLoaded: (state) => Object.keys(state.order).length > 2,

    /** Get the order **/
    order: (state) => state.order,

    /** Get the order availability **/
    orderAvailability: (state) => state.orderAvailability,

    /** Get the devices on an order **/
    orderDevices: (state) => state.order.devices,

    /** Get van details on an order **/
    orderTrackingVan: (state) => state.order.trackingVan,
};

/**
 * Actions
 */
const actions = {
    /** Reset State **/
    resetOrderState({commit}) {
        commit('SET_ORDER', {
            devices: {},
            trackingVan: null
        });
        commit('SET_ORDER_AVAILABILITY', {});
    },
    /** Cancel the order */
    cancelOrder(__, {order}) {
        let data = {
            order_id:order.booking.order_id,
            email: order.details.email,
        };

        return new Promise((resolve, reject) => {
            this.$axios.get(`/api/v4/orders/${data.order_id}/cancel?email_to_verify=${data.email}`)
                .then(() => {
                    resolve();
                }).catch(e => {
                    reject(e);
                });
        })
    },

    /** Change the order address */
    changeOrderAddress(__, {order}) {
        let data = {
            order_id:order.booking.order_id,
            line_1: order.details.address_1,
            line_2: order.details.address_2,
            town: order.details.town,
            postcode: order.details.postcode,
            email_to_verify: order.details.email,
        };

        return new Promise((resolve, reject) => {
            this.$axios.put(`/api/v4/orders/${data.order_id}/address`, data)
                .then(() => {
                    resolve();
                }).catch(e => {
                    reject(e);
                });
        })
    },

    /** Change the repair date */
    changeOrderDate(__, {day, order}) {
        let data = {
            order_id:order.booking.order_id,
            email: order.details.email,
        }

        return new Promise((resolve, reject) => {
            this.$axios.put(`/api/v4/orders/${data.order_id}/date?email_to_verify=${data.email}`, {
                date: day
            }).then(() => {
                resolve();
            }).catch(e => {
                reject(e);
            });
        })
    },

    /** Load available dates */
    loadOrderAvailability({commit}, {order}) {
        return new Promise((resolve, reject) => {
            let today = new Date();
            let date = today.getFullYear() + "-" + (today.getMonth()+1) + "-" + today.getDate();
            this.$axios.get(`/api/v4/orders/${order}/load-days/${date}/10`).then(response => {
                commit('SET_ORDER_AVAILABILITY', response.data.data);
                resolve();
            }).catch(() => {
                reject();
            })
        });
    },

    /** Retrieve the order details to manage */
    retrieveOrder({commit}, {orderRef, email}) {
        return new Promise((resolve, reject) => {
            this.$axios.get(`/api/v4/customer/${orderRef}?email=${email}`)
                .then(response => {
                    commit('SET_ORDER', response.data.data);
                    resolve();
                }).catch(error => {
                    reject(error);
                })
        });
    },

    /** Retrieve the order details to manage */
    retrieveOrderDevices({commit}, {orderRef, email}) {
        return new Promise((resolve) => {
            this.$axios.get(`/api/v4/customer/${orderRef}/devices?email=${email}`)
                .then(response => {
                    commit('SET_ORDER_DEVICES', response.data.data);
                    resolve();
                });
        });
    },

    /** Retrieve the van to track */
    retrieveTrackingVan({commit}, {jobId, email}) {
        return new Promise((resolve) => {
            this.$axios.get(`/api/v4/vans/location?job_id=${jobId}&email=${email}`)
                .then(response => {
                    commit('SET_TRACKING_VAN', response.data.data);
                    resolve();
                }).catch(() => {
                    resolve();
                });
        });
    },

    /** Set the device IMEI */
    setOrderDeviceImei(__, {deviceId, imei, order}) {
        let data = {
            imei: imei,
            email: order.details.email,
            customer_update: true
        }

        return new Promise((resolve, reject) => {
            this.$axios.post(`/api/v4/orders/devices/${deviceId}/imei`, data)
            .then(() => {
                resolve();
            }).catch(e => {
                reject(e);
            });
        });
    },

    /** Upload the proof of purchase */
    uploadOrderDeviceProofOfPurchase(__, {deviceId, formData}) {
        return new Promise((resolve, reject) => {
            this.$axios.post(`/api/v4/orders/devices/${deviceId}/validation-images`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(() => {
                resolve();
            }).catch(e => {
                reject(e);
            });
        })
    }
};

/**
 * Mutations
 */
const mutations = {
    /** Set order */
    SET_ORDER(state, response) {
        state.order = response;
    },

    SET_ORDER_AVAILABILITY(state, response) {
        state.orderAvailability = response;
    },

    /** Set order devices */
    SET_ORDER_DEVICES(state, response) {
        state.order.devices = response;
    },

    /** Set order devices */
    SET_TRACKING_VAN(state, response) {
        state.order.trackingVan = response;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}